module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "figc"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg5_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ack-title"
  }, [_vm._v("DEDICATION")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("To John, Joey, and Adair,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("You are the brightest stars in my life. May your love and kindness continue to shine through all your lifelong journeys.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Love, Alex (Mom)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ed8d6e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_dedication.vue
// module id = 63
// module chunks = 0